import React from "react";
import { motion } from "framer-motion";

// 70 / 20 / 10 ring chart. Each slice animates in.
const SLICES = [
  { key: "hunter",   label: "Hunter",            pct: 70, color: "#FFC107" },
  { key: "treasury", label: "Sovereign Treasury", pct: 20, color: "#ef4444" },
  { key: "donation", label: "CyberKids Donation", pct: 10, color: "#22d3ee" },
];

const polar = (cx, cy, r, deg) => {
  const rad = (deg - 90) * (Math.PI / 180);
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
};
const arcPath = (cx, cy, r, startDeg, endDeg) => {
  const start = polar(cx, cy, r, endDeg);
  const end = polar(cx, cy, r, startDeg);
  const large = endDeg - startDeg <= 180 ? "0" : "1";
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${large} 0 ${end.x} ${end.y}`;
};

export const SplitVisualizer = ({ payout = 0, hunter = 0, treasury = 0, donation = 0, compact = false }) => {
  const size = compact ? 140 : 200;
  const cx = size / 2, cy = size / 2;
  const r = size / 2 - 14;
  let cursor = 0;
  const arcs = SLICES.map((s) => {
    const start = (cursor / 100) * 360;
    cursor += s.pct;
    const end = (cursor / 100) * 360;
    return { ...s, start, end };
  });
  const values = { hunter, treasury, donation };

  return (
    <div className="flex items-center gap-5 flex-wrap" data-testid="split-visualizer">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={cx} cy={cy} r={r} fill="transparent" stroke="rgba(255,255,255,0.06)" strokeWidth="14" />
        {arcs.map((a, i) => (
          <motion.path
            key={a.key}
            d={arcPath(cx, cy, r, a.start, a.end)}
            stroke={a.color}
            strokeWidth="14"
            strokeLinecap="butt"
            fill="none"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ delay: i * 0.25, duration: 0.7, ease: "easeOut" }}
          />
        ))}
        <text x={cx} y={cy - 4} textAnchor="middle" fontSize={compact ? 14 : 18} fontWeight="800" fill="#FFC107" fontFamily="ui-monospace">
          ${payout.toFixed(2)}
        </text>
        <text x={cx} y={cy + 14} textAnchor="middle" fontSize="9" letterSpacing="2" fill="rgba(255,255,255,0.55)">
          PAYOUT
        </text>
      </svg>
      <div className="flex-1 min-w-[180px] space-y-2">
        {arcs.map((a) => (
          <div key={a.key} className="flex items-center justify-between gap-3 text-sm" data-testid={`split-row-${a.key}`}>
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-sm" style={{ background: a.color }} />
              <span className="font-display font-bold text-white/90">{a.label}</span>
              <span className="text-white/40 text-xs">{a.pct}%</span>
            </div>
            <span className="font-mono font-bold text-yellow-200">
              ${(values[a.key] ?? 0).toFixed(2)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SplitVisualizer;
